var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"font-weight-semibold"},[_vm._v(" Liste des décodeurs à échéance ")]),_c('v-divider'),_c('br'),_c('liste-decodeur-echeance')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }